let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eJgH8")).then(() => parcelRequire('gU4LI'));